import React from 'react';

/** Lazy ClientComputedContactForm (not wrapped in a suspense to use the parent widget loading fallback) */
export const ClientComputedContactForm = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'widget-contact-form' */
            './ClientComputedContactForm'
        ),
);
